<template>
	<div class="neighbourhood-component">
		<div class="container">
			<div class="map">
				<div id="map" style="width: 100%; height: 100%;"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import constants from '../constants';
	import _ from 'lodash';

	export default {

		props: ['nbUnits', 'latitude', 'longitude'],

		data() {
			return {
				gm: null,
			};
		},

		mounted() {
			this.appendGmScripts();
		},

		methods: {
			appendGmScripts() {
				var apiKey = constants.googleMapsApiKey();
				var callback = "gmCallback";

				var gmCallBack = document.createElement('script');
				gmCallBack.appendChild(document.createTextNode("function " + callback + "() { app.$refs.neighbourhood.gmCallback(); }"));
				document.body.appendChild(gmCallBack);

				var gmScript = document.createElement('script');
				gmScript.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=' + callback);
				gmScript.async = true;
				gmScript.defer = true;
				document.body.appendChild(gmScript);
			},

			gmCallback() {
				this.gm = new google.maps.Map(document.getElementById('map'), constants.googleMapsOptions(true));

				this.setInitialMarkers();
			},

			setInitialMarkers() {
				new google.maps.Marker({
					position: {lat: this.latitude, lng: this.longitude},
					icon: "/images/curseur.png",
					map: this.gm,
				});

				this.fitBounds();
			},

			fitBounds() {
				let bounds = new google.maps.LatLngBounds();
				bounds.extend({lat: this.latitude, lng: this.longitude});

				let extend = 0.006;
				let extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + extend, bounds.getNorthEast().lng() + extend);
				let extendPoint2 = new google.maps.LatLng(bounds.getSouthWest().lat() - extend, bounds.getSouthWest().lng() - extend);
				bounds.extend(extendPoint1);
				bounds.extend(extendPoint2);

				this.gm.fitBounds(bounds);
			},

			refresh() {
				if (typeof google !== 'undefined') {
					google.maps.event.trigger(this.gm, 'resize');
					this.fitBounds();
				}
			},
		}
	}
</script>
